
// components/SwEventDrawer/components/PaymentOptionsSection.jsx
import React from 'react';

const PaymentOptionsSection = ({ formik, handlePaymentOptionChange }) => {
  return (
    <div className="sw-event-modal-section">
      <div className="sw-event-section-header">
        Payment Options
      </div>
      
      <div className="sw-payment-options-container">
       {/*  <div 
          className={`sw-payment-option-card ${formik.values.paymentOption === 'bankTransfer' ? 'selected' : ''}`}
          onClick={() => handlePaymentOptionChange('bankTransfer')}
        >
          <div className="sw-payment-option-content">
            <div className="sw-payment-option-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path opacity="0.4" fillRule="evenodd" clipRule="evenodd" d="M16.7292 6.32755L12.0172 2.48995C10.8812 1.56195 9.23078 1.56195 8.09478 2.48995L3.38357 6.32675C2.65637 6.91715 2.23877 7.79235 2.23877 8.72912V14.7987C2.23877 16.6771 3.76757 18.2059 5.64677 18.2059H14.4652C16.3444 18.2059 17.8732 16.6771 17.8732 14.7987V8.72912C17.8732 7.79235 17.4556 6.91715 16.7292 6.32755Z" fill="#2C264B"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M12.7009 14.3911C12.7009 14.7687 12.3937 15.0791 12.0161 15.0791H8.09607C7.71771 15.0791 7.41211 14.7687 7.41211 14.3911V11.7519C7.41211 10.2879 8.59527 9.10547 10.0561 9.10547C11.5169 9.10547 12.7009 10.2879 12.7009 11.7519V14.3911Z" fill="#2C264B"/>
              </svg>
            </div>
            <span className="sw-payment-option-text">
              Pay with Bank Transfer
            </span>
          </div>
          <div className="sw-payment-option-radio">
            <div className={`sw-radio-custom ${formik.values.paymentOption === 'bankTransfer' ? 'checked' : ''}`}>
              <div className="sw-radio-inner"></div>
            </div>
          </div>
        </div>
 */}
        <div 
          className={`sw-payment-option-card ${formik.values.paymentOption === 'card' ? 'selected' : ''}`}
          onClick={() => handlePaymentOptionChange('card')}
        >
          <div className="sw-payment-option-content">
            <div className="sw-payment-option-icon">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M14.3097 6.01089C14.3097 4.18849 13.1369 2.96289 11.3929 2.96289H4.9953C3.2497 2.96289 2.0769 4.18849 2.0769 6.01089C2.0769 6.07717 2.13063 6.1309 2.1969 6.1309H14.1897C14.256 6.1309 14.3097 6.07717 14.3097 6.01089Z" fill="#2C264B"/>
                <path fillRule="evenodd" clipRule="evenodd" d="M17.5276 8.20584C17.13 7.53864 16.4724 7.08984 15.6252 6.90824C15.4923 6.87944 15.3668 6.98068 15.3668 7.11663V10.3859C15.3668 12.6515 13.838 14.2339 11.6476 14.2339H5.68821C5.50505 14.2339 5.39235 14.4297 5.50434 14.5747C5.90032 15.0872 6.48149 15.4599 7.21399 15.6179L13.4684 16.9595C13.7108 17.0115 13.9476 17.0371 14.1764 17.0371C15.5516 17.0363 16.63 16.1195 16.958 14.5899L17.8364 10.4995C18.0188 9.64507 17.9124 8.85227 17.5276 8.20584Z" fill="#2C264B"/>
                <path opacity="0.4" fillRule="evenodd" clipRule="evenodd" d="M14.3097 10.1951V7.57105C14.3097 7.43851 14.2023 7.33105 14.0697 7.33105H2.3169C2.18436 7.33105 2.0769 7.43851 2.0769 7.57105V10.1951C2.0769 12.0175 3.2497 13.2431 4.9953 13.2431H11.3921C13.1369 13.2431 14.3097 12.0175 14.3097 10.1951Z" fill="#2C264B"/>
              </svg>
            </div>
            <span className="sw-payment-option-text">
              Pay with Debit Card
            </span>
          </div>
          <div className="sw-payment-option-radio">
            <div className={`sw-radio-custom ${formik.values.paymentOption === 'card' ? 'checked' : ''}`}>
              <div className="sw-radio-inner"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Show payment option validation error */}
      {formik.touched.paymentOption && formik.errors.paymentOption && (
        <div style={{ color: '#ff4d4f', fontSize: 12, marginTop: 8 }}>
          {formik.errors.paymentOption}
        </div>
      )}
    </div>
  );
};

export default PaymentOptionsSection;
